import useOffices from "@/hooks/useOffices";
import { OfficeCard } from "@/ui/OfficeCard";
import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { ParallaxHexagon } from "@/ui/ParallaxHexagon";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import bg_1 from "./bg_1.webp";
import bg_2 from "./bg_2.webp";
import bg_3 from "./bg_3.webp";
import bg_4 from "./bg_4.webp";
import image from "./offices.webp";
import classes from "./styles.module.scss";

export default function ({
  className = "pb-6 pt-5 pt-md-6",
  title,
  EditableText,
  EditableImage,
  theme = "light",
}) {
  const offices = useOffices();

  return (
    <div className={cn(className, classes.OfficeCards)} data-bs-theme={theme}>
      <ParallaxBackground anim="y2:x2n:z0" image={bg_1} className={classes.bg_1} />
      <ParallaxBackground anim="y1:x1:z1" image={bg_2} className={classes.bg_2} />
      <ParallaxBackground anim="y1:x0:z0" image={bg_3} floating={false} className={classes.bg_3} />
      <ParallaxBackground anim="y2:x0:z0" image={bg_4} floating={false} className={classes.bg_4} />
      <Container fluid="md">
        <Row className="flex-md-row-reverse">
          <Col xs={12} lg={6}>
            <EditableText path="title" tag="h2" className="mb-4">
              {title}
            </EditableText>
            <Row>
              {offices.map((office, idx) => (
                <Col key={idx} xs={12} sm={6}>
                  <OfficeCard className="border-bottom mb-4" {...office} />
                </Col>
              ))}
            </Row>
          </Col>
          <Col xs={12} lg={6}>
            <ParallaxHexagon translateY={[20, 0]}>
              <EditableImage path="image" size="496x425" src={image} alt="" />
            </ParallaxHexagon>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
